'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PriceBarQuantity = renderWithRef('PriceBarQuantity', null, (e, o)=>jsx(RenderComp, {
        root: "button",
        forwardedRef: o,
        classNames: new Set([
            'swan-button'
        ]),
        props: e,
        children: e.children
    }));

export { PriceBarQuantity };
